import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';

const withTracker = (WrappedComponent) => {
  @observer
  class HOC extends Component {
    componentDidMount() {
      if (window.releaseStage === 'live') {
        if (this.props.RouterData.prevRoute !== this.props.location.pathname) {
          window.gtag('config', 'UA-1616170-7', { page_path: this.props.location.pathname , anonymize_ip: true});
        }

        this.props.RouterData.prevRoute = this.props.location.pathname;
      }
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  }

  HOC.propTypes = {
    RouterData: PropTypes.shape({
      prevRoute: PropTypes.string,
    }),
    location: PropTypes.shape({
      pathname: PropTypes.string,
    }),
  };

  HOC.defaultProps = {
    RouterData: {
      prevRoute: '',
    },
    location: {
      pathname: '',
    },
  };

  return inject('RouterData')(HOC);
};

export default withTracker;
